module.exports = __webpack_public_path__ + "static/media/fb.1ac2ebaa.svg";